<template>
    <el-dialog
        title="请选择您的科目"
        :visible.sync="dialogVisible"
        append-to-body
        custom-class="identity-switch-dialog"
        width="auto"
        >
        <p class="identity-picker-tip">带箭头的分类还有下一级，请选择具体科目。</p>
        <div class="identity-desktop-picker">
            <el-cascader-panel ref="cascader" v-model="identity_id" :options="identityIds" :props="{ value: 'identity_id',label:'title' }" @expand-change="scrollToLatestLevel" @change="getIdentityName">
                <template slot-scope="{ data }">
                    <span class="identity-node-label"><span>{{data.title}}</span><i v-if="hasChildren(data)" class="el-icon-arrow-right identity-branch-icon" title="有下一级" aria-hidden="true"></i></span>
                </template>
            </el-cascader-panel>
        </div>
        <div class="identity-mobile-picker">
            <nav class="identity-trail" aria-label="科目分类路径">
                <button type="button" @click="goMobileLevel(0)">全部科目</button>
                <template v-for="(item,index) in mobileTrail"><i :key="'arrow-'+index" class="el-icon-arrow-right" aria-hidden="true"></i><button :key="item.identity_id" type="button" @click="goMobileLevel(index+1)">{{item.title}}</button></template>
            </nav>
            <button v-if="mobileTrail.length" class="identity-level-back" type="button" @click="goMobileLevel(mobileTrail.length-1)"><i class="el-icon-arrow-left" aria-hidden="true"></i> 返回上一级</button>
            <div class="identity-mobile-options" aria-label="当前科目分类">
                <button v-for="item in mobileOptions" :key="item.identity_id" type="button" class="identity-mobile-option" :class="{selected:isSelected(item)}" @click="chooseMobile(item)">
                    <span>{{item.title}}</span><span v-if="hasChildren(item)" class="identity-next">下一级<i class="el-icon-arrow-right" aria-hidden="true"></i></span><i v-else-if="isSelected(item)" class="el-icon-check" aria-label="当前科目"></i>
                </button>
            </div>
            <p v-if="!mobileOptions.length" class="identity-picker-tip">暂无下级科目，请返回上一级选择。</p>
        </div>
    </el-dialog>
</template>

<script>
import {isLastIdentity, normalizeIdentityTree} from '@/plugins/identityTree.mjs'
export default {
    data(){
        return{
            dialogVisible:false,
            identity_id:[],
            identityIds:[],
            mobilePath:[]
        }
    },
    computed:{
        mobileTrail(){
            const trail = [];
            let options = this.identityIds;
            for (const id of this.mobilePath) {
                const item = options.find(item => String(item.identity_id) === String(id));
                if (!item || !this.hasChildren(item)) break;
                trail.push(item);
                options = item.children;
            }
            return trail;
        },
        mobileOptions(){
            const parent = this.mobileTrail[this.mobileTrail.length-1];
            return parent ? parent.children : this.identityIds;
        }
    },
    methods:{
        hasChildren(item){
            return !isLastIdentity(item);
        },
        isSelected(item){
            return !this.hasChildren(item) && String(item.identity_id) === String(this.identity_id[this.identity_id.length-1]);
        },
        goMobileLevel(depth){
            this.mobilePath = this.mobileTrail.slice(0,depth).map(item => item.identity_id);
        },
        chooseMobile(item){
            const path = this.mobileTrail.map(item => item.identity_id).concat(item.identity_id);
            if (this.hasChildren(item)) this.mobilePath = path;
            else this.getIdentityName(path);
        },
        scrollToLatestLevel(){
            this.$nextTick(() => {
                // 等级菜单更新完成后，再定位到最右侧新展开的一列。
                setTimeout(() => {
                    const panel = this.$refs.cascader && this.$refs.cascader.$el;
                    const body = panel && panel.closest('.el-dialog__body');
                    if(body) body.scrollLeft = body.scrollWidth - body.clientWidth;
                }, 0);
            });
        },
        getIdentityName(value){
            let options = this.identityIds, selected;
            for (const id of Array.isArray(value) ? value : []) {
                selected = options.find(item => String(item.identity_id) === String(id));
                if (!selected) return;
                options = selected.children || [];
            }
            if (!selected || !isLastIdentity(selected)) return;
            // The parent commits the selected identity only after switchIdentity succeeds.
            this.$emit('update', Array.isArray(value) ? value.slice() : [])
            this.dialogVisible = false
        },
        open(identity_id,identityIds){
            // Cascader mutates its model; do not let it mutate the active path by reference.
            this.identity_id = Array.isArray(identity_id) ? identity_id.slice() : [];
            this.identityIds = normalizeIdentityTree(identityIds);
            this.mobilePath = this.identity_id.slice(0,-1);
            this.dialogVisible = true;
            this.scrollToLatestLevel();
        }
    },

}
</script>

<style scoped>
::v-deep .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #bd7144;
}
::v-deep .el-cascader-panel .el-cascader-node.is-active {
    color: #bd7144;
}
</style>
<style lang="scss">
.identity-switch-dialog {
    width: max-content !important;
    max-width: calc(100vw - 32px);
    min-width: min(540px, calc(100vw - 32px));
    border-radius: 16px;
    overflow: hidden;

    .el-dialog__header {
        padding: 24px 28px 18px;
        border-bottom: 1px solid #edf0f2;
    }
    .el-dialog__title {
        color: #263549;
        font-size: 19px;
        font-weight: 700;
    }
    .el-dialog__body {
        padding: 20px 28px 28px;
        min-height: 0;
        overflow-x: auto;
    }
    .identity-picker-tip { margin: 0 0 14px; color: #84909e; font-size: 12px; line-height: 1.6; }
    .el-cascader-panel {
        width: max-content;
        min-width: 0;
    }
    .el-cascader-menu {
        width: max-content;
        min-width: 160px;
        flex: none;
    }
    .el-cascader-node {
        box-sizing: border-box;
        width: auto;
        min-width: 0;
        padding: 0 16px 0 24px;
    }
    .el-cascader-node__label { white-space: nowrap; padding: 0; }
    .el-cascader-node__postfix { display: none; }
    .identity-node-label { display: flex; align-items: center; justify-content: space-between; gap: 22px; }
    .identity-branch-icon { flex: none; color: #9aa7b4; font-size: 12px; }
    .el-cascader-node.in-active-path .identity-branch-icon { color: #bd7144; }
    .identity-mobile-picker { display: none; }
}
@media (max-width: 700px) {
    .identity-switch-dialog {
        display: flex;
        flex-direction: column;
        width: calc(100vw - 24px) !important;
        max-width: calc(100vw - 24px);
        min-width: 0;
        max-height: calc(100vh - 32px);
        max-height: calc(100dvh - 32px);
        margin: 16px auto !important;
        .el-dialog__header { flex: none; padding: 20px 20px 16px; }
        .el-dialog__title { font-size: 18px; }
        .el-dialog__body { flex: 1; padding: 16px 18px 20px; overflow-y: auto; overflow-x: hidden; overscroll-behavior: contain; }
        .identity-desktop-picker { display: none; }
        .identity-mobile-picker { display: block; }
        .identity-trail { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; font-size: 12px; color: #a9b2be; }
        .identity-trail button { border: 0; padding: 3px 0; background: none; color: #8b654b; font: inherit; line-height: 1.6; text-align: left; overflow-wrap: anywhere; cursor: pointer; }
        .identity-level-back { display: flex; align-items: center; gap: 6px; min-height: 36px; margin: 0 0 10px; padding: 0 10px; border: 1px solid #eee3da; border-radius: 7px; color: #9d6948; background: #fffbf7; cursor: pointer; }
        .identity-mobile-options { border: 1px solid #e8edf2; border-radius: 10px; overflow: hidden; }
        .identity-mobile-option { display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; min-height: 50px; padding: 13px 14px; border: 0; border-bottom: 1px solid #edf0f3; background: #fff; color: #435168; font: inherit; font-size: 14px; line-height: 1.6; text-align: left; cursor: pointer; }
        .identity-mobile-option:last-child { border-bottom: 0; }
        .identity-mobile-option > span:first-child { min-width: 0; overflow-wrap: anywhere; }
        .identity-mobile-option.selected { background: #fff6ed; color: #b66b3b; font-weight: 600; }
        .identity-mobile-option > i { flex: none; color: #b66b3b; }
        .identity-next { display: flex; align-items: center; gap: 8px; flex: none; color: #9da6b2; font-size: 11px; }
    }
}
</style>
